import type { ProjectStatusValue } from '@kreart/shared';

export function projectStatusBadgeClass(status: ProjectStatusValue): string {
  switch (status) {
    case 'ACCEPTED':
      return 'bg-chart-3/30 text-foreground';
    case 'IN_WARRANTY':
      return 'bg-chart-1/30 text-foreground';
    case 'IN_PROGRESS':
      return 'bg-primary/10 text-primary';
    case 'ON_HOLD':
      return 'bg-muted text-muted-foreground';
    case 'SENT_TO_CLIENT':
      return 'bg-chart-2/30 text-foreground';
    case 'REOFFER':
      return 'bg-chart-4/30 text-foreground';
    case 'REJECTED':
      return 'bg-destructive/10 text-destructive';
    default:
      return 'bg-muted text-muted-foreground';
  }
}

export const PROJECT_STATUS_VALUES: ProjectStatusValue[] = [
  'IN_PROGRESS',
  'ON_HOLD',
  'SENT_TO_CLIENT',
  'REOFFER',
  'ACCEPTED',
  'IN_WARRANTY',
  'REJECTED',
];
